import React from "react"
import { FormNavigationContext } from "./Form"
import SlidingPane from "./SlidingPane"

export default class QuestionPane extends React.Component {
  state = {
    visible: false,
  }

  isQuestionPaneVisible(value) {
    return this.props.identifiers.indexOf(value.activeIdentifier) > -1
  }

  componentWillMount() {
    this.props.registerContext(this.context)
    this.setState({
      visible: this.isQuestionPaneVisible(this.context),
    })
  }

  componentDidUpdate() {
    this.props.registerContext(this.context)
  }

  render() {
    return (
      <FormNavigationContext.Consumer>
        {value => {
          if (this.isQuestionPaneVisible(value) !== this.state.visible) {
            this.props.paneWillShow(this.props.identifiers)
            this.setState({
              visible: this.isQuestionPaneVisible(value),
            })
          }
          return (
            <SlidingPane
              visible={this.state.visible}
              backwards={!value.forward}
            >
              {/* {this.isQuestionPaneVisible(value) && this.props.children} */}
              {this.props.children}
            </SlidingPane>
          )
        }}
      </FormNavigationContext.Consumer>
    )
  }
}

QuestionPane.defaultProps = {
  adjustHeight: () => {},
  registerContext: () => {},
  paneWillShow: () => {},
}

QuestionPane.contextType = FormNavigationContext
